var render = function render(){var _vm=this,_c=_vm._self._c;return _c('wizard',_vm._g({attrs:{"progress":_vm.progress,"wide":_vm.isOnIntro}},_vm.listeners),[_c('transition-fade',[_c('router-view',{staticClass:"wizard__screen"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }